export enum Routes {
  LoginPage = "/login",
  RegistrationPage = "/registration",
  ForgotPasswordPage = "/forgot-password",
  /** Ulaz kad naše osoblje otvori aplikaciju kao klijentov korisnik. */
  ImpersonatePage = "/impersonate",
  HomePage = "/",
  OfflinePage = "/offline",
  UnauthorizedPage = "/unauthorized",
}
